import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { isEmpty } from 'lodash'

const defaultState = {
  extendedFiltersModalOpen: false,
  form: {
    customer: '',
    dessin: [],
    height: {
      max: '',
      min: '',
    },
    idOrName: '',
    orderYear: {
      max: '',
      min: '',
    },
    producer: [],
    quality: [],
    source: [],
    status: [],
    width: {
      max: '',
      min: '',
    },
  },
}

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'SearchFormContainer'

    static propTypes = {
      applyExtendedFilters: PropTypes.func.isRequired,
      applyFilters: PropTypes.func.isRequired,
      filters: PropTypes.object.isRequired,
      params: PropTypes.object.isRequired,
      removeQueryFromUrl: PropTypes.func.isRequired,
      resetFilters: PropTypes.func.isRequired,
      statusOptions: PropTypes.array.isRequired,
      toggleMySearchesSaveModal: PropTypes.func.isRequired,
    }

    state = {
      extendedFiltersModalOpen: false,
      form: this.props.filters,
    }

    componentDidMount() {
      const { applyFilters, applyExtendedFilters, params, removeQueryFromUrl } = this.props

      if (!isEmpty(params)) {
        applyFilters(params.filters)
        applyExtendedFilters(params.extendedFilters)

        this.setState(
          {
            form: {
              ...params.filters,
            },
          },
          () => removeQueryFromUrl(),
        )
      }
    }

    handleCustomer = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          customer: value,
        },
      })
    }

    handleDessin = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          dessin: value,
        },
      })
    }

    handleHeightMax = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          height: {
            max: value,
            min: form.height.min,
          },
        },
      })
    }

    handleHeightMin = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          height: {
            max: form.height.max,
            min: value,
          },
        },
      })
    }

    handleIdOrName = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          idOrName: value,
        },
      })
    }

    handleOrderYearMax = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          orderYear: {
            max: value,
            min: form.orderYear.min,
          },
        },
      })
    }

    handleOrderYearMin = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          orderYear: {
            max: form.orderYear.max,
            min: value,
          },
        },
      })
    }

    handleProducer = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          producer: value,
        },
      })
    }

    handleQuality = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          quality: value,
        },
      })
    }

    handleReset = e => {
      const { resetFilters } = this.props

      e.preventDefault()
      resetFilters()
      this.setState(defaultState)
    }

    handleSave = e => {
      const { toggleMySearchesSaveModal } = this.props

      e.preventDefault()

      toggleMySearchesSaveModal()
    }

    handleStatus = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          status: value,
        },
      })
    }

    handleSubmit = e => {
      const { applyFilters } = this.props
      const { form } = this.state

      if (e) {
        e.preventDefault()
      }

      applyFilters(form)
    }

    handleWidthMax = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          width: {
            max: value,
            min: form.width.min,
          },
        },
      })
    }

    handleWidthMin = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          width: {
            max: form.width.max,
            min: value,
          },
        },
      })
    }

    toggleExtendedFiltersModal = e => {
      const { extendedFiltersModalOpen } = this.state

      if (e) {
        e.preventDefault()
      }

      this.setState({ extendedFiltersModalOpen: !extendedFiltersModalOpen })
    }

    render() {
      const { extendedFiltersModalOpen, form } = this.state

      return (
        <WrappedComponent
          extendedFiltersModalOpen={extendedFiltersModalOpen}
          form={form}
          handleCustomer={this.handleCustomer}
          handleDessin={this.handleDessin}
          handleHeightMax={this.handleHeightMax}
          handleHeightMin={this.handleHeightMin}
          handleIdOrName={this.handleIdOrName}
          handleOrderYearMax={this.handleOrderYearMax}
          handleOrderYearMin={this.handleOrderYearMin}
          handleProducer={this.handleProducer}
          handleQuality={this.handleQuality}
          handleReset={this.handleReset}
          handleSave={this.handleSave}
          handleStatus={this.handleStatus}
          handleSubmit={this.handleSubmit}
          handleWidthMax={this.handleWidthMax}
          handleWidthMin={this.handleWidthMin}
          toggleExtendedFiltersModal={this.toggleExtendedFiltersModal}
          {...this.props}
        />
      )
    }
  }

  return Container
}
